import React from "react";
import { Outlet } from "react-router-dom";

/**
 * OpenRoutes - Routes accessible to everyone (both authenticated and unauthenticated users)
 * Unlike PublicRoutes, this doesn't redirect authenticated users
 * Use this for truly public pages like vendor forms, landing pages, etc.
 */
const OpenRoutes = () => {
  return <Outlet />;
};

export default OpenRoutes;


